import React from "react";

const CredlixVsOthers = ({ data }) => {
  if (!data) return null;

  const getFeatureIcon = (type) => {
    switch (type) {
      case "guidance":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="6" />
            <circle cx="12" cy="12" r="2" />
            <path d="M19 5l-3 3" />
          </svg>
        );
      case "advance":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 8 9" />
          </svg>
        );
      case "collateral":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M9 11l2 2 4-4" />
          </svg>
        );
      case "funds":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        );
      case "nonRecourse":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <rect x="15" y="14" width="7" height="5" rx="1" />
            <path d="M17 14v-2a2 2 0 0 1 4 0v2" />
          </svg>
        );
      case "credibility":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <path d="M8 12h8M8 16h6" />
          </svg>
        );
      case "currency":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        );
      case "coverage":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#022B5C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <section className="bg-[#F0F7FF] py-sp-100 sm:py-20">
      <div className="container px-3">
          <h2
            className="text-secondary text-heading2 sm:text-2xl font-medium text-center"
            dangerouslySetInnerHTML={{ __html: data.heading }}
          />

        <div className="max-w-[920px] mx-auto overflow-x-auto pb-4 mt-6">
        <div className="min-w-[600px] flex flex-col pr-1 shadow-[0px_0px_20px_0px_rgba(0,0,0,0.15)]">
            <div className="flex items-stretch w-full">
              <div className="w-[36%] bg-[#EBF1F6] rounded-tl-2xl px-3 py-2 flex items-center">
                {/* <span className="text-[#03356E] font-bold text-sm">Features</span> */}
              </div>

              <div className="w-[28%] bg-[#E3A003] text-white px-3 py-2 text-center text-xl rounded-t-2xl shadow-[0_-4px_10px_rgba(0,0,0,0.05)] border-t border-l border-r border-[#072F5F] flex items-center justify-center z-10">
                {data.headers.credlix}
              </div>

              <div className="w-[36%] bg-[#EBF1F6] rounded-tr-2xl px-6 sm:px-3 py-2 flex items-center">
                <span className="text-[#072F5F] text-base text-center">
                  {data.headers.others}
                </span>
              </div>
            </div>

            {data.features.map((feature, idx) => {
              const isLast = idx === data.features.length - 1;
              return (
                <div key={feature.id} className="flex items-stretch w-full">
                  <div className={`w-[36%] bg-[#F8FAFC] px-3 py-2 flex items-center gap-4 ${isLast ? "rounded-bl-2xl" : ""}`}>
                    {getFeatureIcon(feature.iconType)}
                    <span className="text-darkBlack text-base sm:text-sm">
                      {feature.title}
                    </span>
                  </div>

                  <div className={`w-[28%] bg-white px-3 py-2 flex items-center justify-center border-l border-r border-[#072F5F] z-10 shadow-[8px_0_15px_-5px_rgba(0,0,0,0.03),-8px_0_15px_-5px_rgba(0,0,0,0.03)] ${isLast ? "rounded-b-2xl border-b border-[#072F5F] shadow-[0_10px_20px_rgba(0,0,0,0.05)]" : ""}`}>
                    <div className="flex items-center gap-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#4A9447" />
                        <path d="M8 12l3 3 5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="text-darkBlack text-base sm:text-sm">
                        {feature.credlix}
                      </span>
                    </div>
                  </div>

                  <div className={`w-[36%] bg-[#F8FAFC] px-12 sm:px-3 py-2 flex items-center gap-2 ${isLast ? "rounded-br-2xl" : ""}`}>
                  <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#979797"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path></svg>
                    <span className="text-darkBlack text-base sm:text-sm">
                      {feature.others}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredlixVsOthers;
